/**
 * @author        quanquan
 * @dateTime      2020-12-09 14:18:51
 * @description   meituanIM Store
 */

import { state } from './utils'

export default _.cloneDeep(state)



// WEBPACK FOOTER //
// ./src/js/conf/home/store/meituanIM/state.js